import { render, staticRenderFns } from "./delete-email.vue?vue&type=template&id=231b8f7f&"
import script from "./delete-email.vue?vue&type=script&lang=js&"
export * from "./delete-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports